export default "__VITE_ASSET__CD77GzU7__"